import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetApplicationVersion =
  ApiClient['v2']['workspaces'][':workspaceId']['applications'][':applicationId']['versions'][':applicationVersionId']['$get'];
export type ApplicationVersionDetailedResponse = InferResponseType<GetApplicationVersion, 200>;

export function useApplicationVersion(
  workspaceId: number,
  applicationId: number,
  applicationVersionId: number
) {
  return useFetch<ApplicationVersionDetailedResponse>(
    `workspaces/${workspaceId}/applications/${applicationId}/versions/${applicationVersionId}`,
    (client) =>
      client.v2.workspaces[':workspaceId'].applications[':applicationId'].versions[
        ':applicationVersionId'
      ].$get({
        param: {
          workspaceId: workspaceId.toString(),
          applicationId: applicationId.toString(),
          applicationVersionId: applicationVersionId.toString(),
        },
      })
  );
}
